import * as actionTypes from './actionTypes';
import { vignetteService } from './services';
import { actionsModalError } from '@app/src/common/modalError';
import { fetchValidateAccess } from '@app/src/common/session';

const fetchVignetteRequest = () => ({
  type: actionTypes.FETCH_VIGNETTE_REQUEST
});

const fetchVignetteSuccess = (data) => ({
  type: actionTypes.FETCH_VIGNETTE_SUCCESS,
  data
});

const fetchVignetteFailure = () => ({
  type: actionTypes.FETCH_VIGNETTE_FAILURE
});

export const fetchVignette = (categoryId:number, publicationId: number): Function => {
  return async dispatch => {
    dispatch(fetchVignetteRequest());
    await dispatch(fetchValidateAccess());
    try {
      const data = await vignetteService.get(categoryId, publicationId);
      dispatch(fetchVignetteSuccess(data));
    } catch(e) {
      dispatch(fetchVignetteFailure());
      dispatch(actionsModalError.openModalError());
    }
  }
};
